var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cs from '../_util/classNames';
import Trigger from '../Trigger';
import IconRight from '../../icon/react-icon/IconRight';
import IconDown from '../../icon/react-icon/IconDown';
import { renderElem, isChildrenSelected } from './util';
import omit from '../_util/omit';
var SubMenuPop = /** @class */ (function (_super) {
    __extends(SubMenuPop, _super);
    function SubMenuPop(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickSubMenu = function () {
            var _a = _this.props, _key = _a._key, onClickSubMenu = _a.onClickSubMenu, level = _a.level, selectable = _a.selectable, onClickMenuItem = _a.onClickMenuItem;
            if (selectable) {
                onClickMenuItem && onClickMenuItem(_key);
            }
            onClickSubMenu && onClickSubMenu(_key, level);
        };
        _this.onVisibleChange = function (visible) {
            var triggerProps = _this.props.triggerProps;
            _this.setState({
                popVisible: visible,
            });
            triggerProps && triggerProps.onVisibleChange && triggerProps.onVisibleChange(visible);
        };
        // 点击菜单项trigger自动关闭
        _this.onClickTriggerItem = function () {
            _this.setState({
                popVisible: false,
            });
            // submenu 嵌套 submenu 的时候，点击最后一层的选项，之前的每一层级的菜单都需要关闭
            if (_this.props.triggerItemClick) {
                _this.props.triggerItemClick();
            }
        };
        _this.state = {
            popVisible: false,
        };
        return _this;
    }
    SubMenuPop.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, title = _c.title, children = _c.children, openKeys = _c.openKeys, prefixCls = _c.prefixCls, mode = _c.mode, level = _c.level, theme = _c.theme, collapse = _c.collapse, className = _c.className, popClassName = _c.popClassName, _d = _c.selectedKeys, selectedKeys = _d === void 0 ? [] : _d, selectable = _c.selectable, icons = _c.icons, triggerProps = _c.triggerProps, rest = __rest(_c, ["title", "children", "openKeys", "prefixCls", "mode", "level", "theme", "collapse", "className", "popClassName", "selectedKeys", "selectable", "icons", "triggerProps"]);
        var selected = selectable && selectedKeys.indexOf(this.props._key) > -1;
        var baseClassName = prefixCls + "-pop";
        var contentClassNames = cs(baseClassName + "-content");
        var classNamesTrigger = cs(baseClassName + "-trigger", (_a = {},
            _a[baseClassName + "-trigger-dark"] = theme === 'dark',
            _a[baseClassName + "-trigger-horizontal"] = mode === 'horizontal',
            _a), popClassName);
        var classNamesHeader = cs(baseClassName + "-header", (_b = {},
            _b[baseClassName + "-header-selected"] = isChildrenSelected(children, selectedKeys) || selected,
            _b), className);
        var currentLevel = level + 1;
        var childrenContent = function () {
            return (React.createElement("div", { className: contentClassNames }, React.Children.map(children, function (child) {
                return renderElem(child, __assign(__assign({}, omit(rest, ['style'])), { mode: mode,
                    theme: theme, level: currentLevel, prefixCls: prefixCls,
                    openKeys: openKeys,
                    collapse: collapse,
                    selectedKeys: selectedKeys, triggerItemClick: _this.onClickTriggerItem, icons: icons }));
            })));
        };
        return (React.createElement(Trigger, __assign({ popup: childrenContent, childrenPrefix: baseClassName, popupVisible: this.state.popVisible, trigger: "hover", position: mode === 'horizontal' && level === 1 ? 'bl' : 'rt', mouseLeaveDelay: 200, mouseEnterDelay: 200, className: classNamesTrigger, autoAlignPopupMinWidth: true }, triggerProps, { onVisibleChange: function (visible) {
                _this.onVisibleChange(visible);
            } }),
            React.createElement("div", { className: baseClassName },
                React.createElement("div", { className: classNamesHeader, onClick: this.onClickSubMenu },
                    title,
                    level !== 1 && React.createElement("span", { className: baseClassName + "-header-placeholder" }),
                    !collapse && mode === 'horizontal' && level === 1 && (React.createElement("span", { className: prefixCls + "-icon-suffix-down" }, icons && icons.horizontalArrowDown ? icons.horizontalArrowDown : React.createElement(IconDown, null))),
                    ((!collapse && mode !== 'horizontal') || level !== 1) && (React.createElement("span", { className: prefixCls + "-icon-suffix" }, icons && icons.popArrowRight ? icons.popArrowRight : React.createElement(IconRight, null)))))));
    };
    SubMenuPop.propTypes = {
        // style: PropTypes.object,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    };
    return SubMenuPop;
}(Component));
export default SubMenuPop;
